// extracted by mini-css-extract-plugin
export default {"hdWrap":"header_hdWrap__RADgw","logoBox":"header_logoBox__8Pl6V","logo":"header_logo__UESgy","logoText":"header_logoText__kYUFs","lauchApp":"header_lauchApp__qkc7W"};